import { useContext, useEffect, useState } from "react";
import { getRaces } from "../../../api/raceApi";
import { getPhases } from "../../../api/phaseApi";
import { getUsers } from "../../../api/usersApi";
import { addAnimal, getAnimalById, getAnimals, updateAnimal } from "../../../api/animalsApi";
import { addReproduction, getReproductionByAnimal, updateReproduction } from "../../../api/reproductionApi";
import { getStatus, getStatusById, getStatusByName } from "../../../api/statusApi";
import { useNavigate, useParams } from "react-router-dom";
import "./adminAddEdit.css";
import swal from "sweetalert";
import { AuthContext } from "../../../Contexts/AuthContext";
import { GiCow } from "react-icons/gi";
import { useTranslation } from "react-i18next";
import { FiHash, FiTag, FiCalendar, FiActivity, FiUsers, FiHeart, FiChevronLeft, FiCheckCircle, FiAlertCircle } from "react-icons/fi";
import { TbWeight, TbGenderBigender } from "react-icons/tb";
import { MdPets } from "react-icons/md";

export const AdminAddEditAnimal = ({ edit = false }) => {
  const { user } = useContext(AuthContext);
  const { t } = useTranslation();

  const [numero, setNumero] = useState("");
  const [nom, setNom] = useState("");
  const [dateNaissance, setDateNaissance] = useState("");
  const [phaseId, setPhaseId] = useState("");
  const [raceId, setRaceId] = useState("");
  const [userId, setUserId] = useState("");
  const [poids, setPoids] = useState("");
  const [genre, setGenre] = useState("");
  const [motherId, setMotherId] = useState("");
  const [animals, setAnimals] = useState([]);
  const [statusId, setStatusId] = useState("");
  const [statuss, setStatuss] = useState([]);

  const [reprodId, setReprodId] = useState("");
  const [reprodDV, setReprodDV] = useState("");
  const [reprodDS, setReprodDS] = useState("");
  const [reprodDG, setReprodDG] = useState("");

  const [races, setRaces] = useState([]);
  const [phases, setPhases] = useState([]);
  const [users, setUsers] = useState([]);
  const [error, setError] = useState("");

  const navigate = useNavigate();
  const { id } = useParams();
  const today = new Date();

  useEffect(() => {
    getRaces().then((data) => setRaces(data));
    getPhases().then((data) => setPhases(data));
    getUsers().then((data) => setUsers(data));
    getStatus().then((data) => setStatuss(data));
    getAnimals().then((data) => setAnimals(data));
  }, []);

  useEffect(() => {
    if (!edit && id) {
      setMotherId(id);
    }

    if (edit && id) {
      getAnimalById(id).then((data) => {
        setNumero(data.numero || "");
        setNom(data.nom || "");
        setDateNaissance(data.date_naissance || "");
        setPhaseId(data.phase_id || "");
        setRaceId(data.race_id || "");
        setPoids(data.poids || "");
        setGenre(data.genre || "");
        setUserId(data.user_id || "");
        setMotherId(data.mother_id || "");
      });

      getReproductionByAnimal(id).then((data) => {
        setReprodId(data.id);
        setReprodDV(data.date_velage || "");
        setReprodDS(data.date_saille || "");
        setReprodDG(data.date_gestation || "");
        setStatusId(data.status_id);
      });
    }
  }, [edit, id]);

  const validateForm = async () => {
    const birthDate = new Date(dateNaissance);
    const ageDays = (today - birthDate) / (1000 * 60 * 60 * 24);
    let statusName = null;

    try {
      const statusData = await getStatusById(statusId);
      statusName = statusData.titre;
    } catch {
      setError(t("adminAddEditAnimal.validation.statusFetchError"));
      return false;
    }

    if (statusName !== "croissance") {
      if (ageDays < 365) {
        setError(t("adminAddEditAnimal.validation.invalidAgeStatus"));
        return false;
      }
      if (genre === "male") {
        setError(t("adminAddEditAnimal.validation.maleStatusError", { status: statusName }));
        return false;
      }
    }

    if (statusName === "croissance") {
      if (ageDays >= 730) {
        setError(t("adminAddEditAnimal.validation.growthAgeError"));
        return false;
      }

      if (reprodDS || reprodDV || reprodDG) {
        setError(t("adminAddEditAnimal.validation.growthReproError"));
        return false;
      }
    }

    const filledDates = [reprodDV, reprodDS].filter((date) => date && date.trim() !== "");
    const uniqueDates = new Set(filledDates);

    if (filledDates.length > 0 && uniqueDates.size < filledDates.length) {
      setError(t("adminAddEditAnimal.validation.duplicateDates"));
      return false;
    }

    if ((statusName === "Gestation" || statusName === "Repos") && !reprodDG) {
      setError(t("adminAddEditAnimal.validation.gestationRequired"));
      return false;
    }

    if ((statusName === "Saillie" || statusName === "Oestrus") && !reprodDS) {
      setError(t("adminAddEditAnimal.validation.saillieRequired"));
      return false;
    }

    if (statusName === "V�lage" && !reprodDV) {
      setError(t("adminAddEditAnimal.validation.velageRequired"));
      return false;
    }

    if (reprodDV && new Date(reprodDV) > today) {
      setError(t("adminAddEditAnimal.validation.futureVelage"));
      return false;
    }

    if (reprodDS && new Date(reprodDS) > today) {
      setError(t("adminAddEditAnimal.validation.futureSaillie"));
      return false;
    }

    if (reprodDG && new Date(reprodDG) > today) {
      setError(t("adminAddEditAnimal.validation.futureGestation"));
      return false;
    }

    setError("");
    return true;
  };

  async function handleSubmit(e) {
    e.preventDefault();
    const isValid = await validateForm();
    if (!isValid) return;

    const animalData = {
      numero,
      nom,
      date_naissance: dateNaissance,
      poids,
      genre,
      phase_id: phaseId,
      race_id: raceId,
      user_id: userId,
      mother_id: motherId || null,
      ferme_id: user.ferme_id,
    };

    try {
      const dateG = reprodDG ? new Date(reprodDG) : null;
      let FStatus = statusId;

      if (reprodDG) {
        const diffDGt = today - dateG;
        const diffTGt = diffDGt / (1000 * 60 * 60 * 24);

        if (diffTGt <= 280 && diffTGt >= 1 && !FStatus) {
          const st = await getStatusByName("Gestation");
          FStatus = st.id;
        }

        if ((diffTGt > 280 || diffTGt < 1) && !FStatus) {
          swal(t("adminAddEditAnimal.validation.statusRequired"), "", "error");
          return;
        }
      }

      if (edit && id) {
        const reproductionDataU = {
          date_velage: reprodDV || null,
          date_saille: reprodDS || reprodDG || null,
          date_gestation: reprodDG || null,
          status_id: FStatus,
        };

        if (reprodId) {
          await updateReproduction(reprodId, reproductionDataU);
        } else {
          const reproductionData = {
            animalId: id,
            date_velage: reprodDV,
            date_saille: reprodDS || reprodDG,
            date_gestation: reprodDG,
            statusId: FStatus || statusId,
          };
          await addReproduction(reproductionData);
        }

        await updateAnimal(id, animalData);
        navigate("/admin/animals");
        return;
      }

      const birthDate = new Date(dateNaissance);
      if (birthDate >= today) {
        swal(t("adminAddEditAnimal.validation.birthFuture"), "", "error");
        return;
      }

      const usedStatusId = FStatus || statusId;
      let statusName = null;

      if (usedStatusId) {
        const statusData = await getStatusById(usedStatusId);
        statusName = statusData.titre;
      }

      const newAnimal = await addAnimal(animalData);
      const createdAnimalId = newAnimal.id;

      if (statusName !== "croissance") {
        const reproductionData = {
          animalId: createdAnimalId,
          date_velage: reprodDV || null,
          date_saille: reprodDS || reprodDG || null,
          date_gestation: reprodDG || null,
          statusId: usedStatusId,
        };
        await addReproduction(reproductionData);
      } else {
        await addReproduction({ animalId: createdAnimalId, statusId: usedStatusId });
      }

      navigate("/admin/animals");
    } catch (err) {
      console.error("Error:", err.response?.data || err.message);
    }
  }

  return (
    <div className="af-page">
      {/* Header */}
      <div className="af-header">
        <button type="button" className="af-back-btn" onClick={() => navigate("/admin/animals")}>
          <FiChevronLeft /> {t("adminAddEditAnimal.buttons.back") || "Retour"}
        </button>
        <div className="af-header-content">
          <div className="af-header-icon">
            <GiCow />
          </div>
          <div>
            <h1 className="af-title">
              {edit ? t("adminAddEditAnimal.titleEdit") : t("adminAddEditAnimal.titleAdd")}
            </h1>
            <p className="af-subtitle">
              {edit
                ? (t("adminAddEditAnimal.subtitleEdit") || "Modifier les informations de l'animal")
                : (t("adminAddEditAnimal.subtitleAdd") || "Remplissez les informations pour enregistrer un nouvel animal")}
            </p>
          </div>
        </div>
      </div>

      {/* Error Alert */}
      {error && (
        <div className="af-error">
          <FiAlertCircle className="af-error-icon" />
          <span>{error}</span>
        </div>
      )}

      <form onSubmit={handleSubmit} className="af-form">
        {/* Section 1: Identity */}
        <div className="af-section">
          <div className="af-section-header">
            <div className="af-section-icon"><FiHash /></div>
            <h3 className="af-section-title">{t("adminAddEditAnimal.sections.identity") || "Identité"}</h3>
          </div>
          <div className="af-grid">
            <div className="af-field">
              <label className="af-label required">
                <FiHash className="af-label-icon" />
                {t("adminAddEditAnimal.fields.numero")}
              </label>
              <input
                type="text"
                className="af-input"
                value={numero}
                onChange={(e) => setNumero(e.target.value)}
                placeholder={t("adminAddEditAnimal.placeholders.numero") || "EX: 12345"}
                required
              />
            </div>
            <div className="af-field">
              <label className="af-label required">
                <FiTag className="af-label-icon" />
                {t("adminAddEditAnimal.fields.nom")}
              </label>
              <input
                type="text"
                className="af-input"
                value={nom}
                onChange={(e) => setNom(e.target.value)}
                placeholder={t("adminAddEditAnimal.placeholders.nom") || "EX: Bella"}
                required
              />
            </div>
            <div className="af-field">
              <label className="af-label required">
                <FiCalendar className="af-label-icon" />
                {t("adminAddEditAnimal.fields.dateNaissance")}
              </label>
              <input type="date" className="af-input" value={dateNaissance} onChange={(e) => setDateNaissance(e.target.value)} required />
            </div>
            <div className="af-field">
              <label className="af-label">
                <TbWeight className="af-label-icon" />
                {t("adminAddEditAnimal.fields.poids")}
              </label>
              <input
                type="text"
                className="af-input"
                value={poids}
                onChange={(e) => setPoids(e.target.value)}
                placeholder={t("adminAddEditAnimal.placeholders.poids") || "EX: 450 kg"}
              />
            </div>
          </div>
        </div>

        {/* Section 2: Characteristics */}
        <div className="af-section">
          <div className="af-section-header">
            <div className="af-section-icon"><MdPets /></div>
            <h3 className="af-section-title">{t("adminAddEditAnimal.sections.characteristics") || "Caractéristiques"}</h3>
          </div>
          <div className="af-grid">
            <div className="af-field">
              <label className="af-label required">
                <TbGenderBigender className="af-label-icon" />
                {t("adminAddEditAnimal.fields.genre")}
              </label>
              <select className="af-select" value={genre} onChange={(e) => setGenre(e.target.value)} required>
                <option value="">{t("adminAddEditAnimal.placeholders.selectGenre")}</option>
                <option value="male">{t("adminAddEditAnimal.gender.male")}</option>
                <option value="femelle">{t("adminAddEditAnimal.gender.female")}</option>
              </select>
            </div>
            <div className="af-field">
              <label className="af-label required">
                <FiActivity className="af-label-icon" />
                {t("adminAddEditAnimal.fields.phase")}
              </label>
              <select className="af-select" value={phaseId} onChange={(e) => setPhaseId(e.target.value)} required>
                <option value="">{t("adminAddEditAnimal.placeholders.selectPhase")}</option>
                {phases.map((phase) => (
                  <option key={phase.id} value={phase.id}>{phase.titre}</option>
                ))}
              </select>
            </div>
            <div className="af-field">
              <label className="af-label required">
                <MdPets className="af-label-icon" />
                {t("adminAddEditAnimal.fields.race")}
              </label>
              <select className="af-select" value={raceId} onChange={(e) => setRaceId(e.target.value)} required>
                <option value="">{t("adminAddEditAnimal.placeholders.selectRace")}</option>
                {races.map((r) => (
                  <option key={r.id} value={r.id}>{r.nom}</option>
                ))}
              </select>
            </div>
            <div className="af-field">
              <label className="af-label af-mother-label">
                <FiHeart className="af-label-icon" />
                {t("adminAddEditAnimal.fields.mother")}
              </label>
              <select className="af-select" value={motherId} onChange={(e) => setMotherId(e.target.value)}>
                <option value="">{t("adminAddEditAnimal.placeholders.selectMother")}</option>
                {animals.map((a) => (
                  <option key={a.id} value={a.id}>{a.numero} - {a.nom}</option>
                ))}
              </select>
            </div>
          </div>
        </div>

        {/* Section 3: Assignment */}
        <div className="af-section">
          <div className="af-section-header">
            <div className="af-section-icon"><FiUsers /></div>
            <h3 className="af-section-title">{t("adminAddEditAnimal.sections.assignment") || "Affectation"}</h3>
          </div>
          <div className="af-grid af-grid-single">
            <div className="af-field">
              <label className="af-label required">
                <FiUsers className="af-label-icon" />
                {t("adminAddEditAnimal.fields.user")}
              </label>
              <select className="af-select" value={userId} onChange={(e) => setUserId(e.target.value)} required>
                <option value="">{t("adminAddEditAnimal.placeholders.selectUser")}</option>
                {users.filter((u) => u.role !== "admin").map((u) => (
                  <option key={u.id} value={u.id}>{u.nom}</option>
                ))}
              </select>
            </div>
          </div>
        </div>

        {/* Section 4: Reproduction */}
        <div className="af-section af-section-repro">
          <div className="af-section-header">
            <div className="af-section-icon af-icon-repro"><GiCow /></div>
            <h3 className="af-section-title">{t("adminAddEditAnimal.reproduction.title")}</h3>
          </div>
          <div className="af-grid">
            <div className="af-field">
              <label className="af-label">
                <FiCalendar className="af-label-icon" />
                {t("adminAddEditAnimal.reproduction.dateSaillie")}
              </label>
              <input type="date" className="af-input" value={reprodDS} onChange={(e) => setReprodDS(e.target.value)} />
            </div>
            <div className="af-field">
              <label className="af-label">
                <FiCalendar className="af-label-icon" />
                {t("adminAddEditAnimal.reproduction.dateVelage")}
              </label>
              <input type="date" className="af-input" value={reprodDV} onChange={(e) => setReprodDV(e.target.value)} />
            </div>
            <div className="af-field">
              <label className="af-label">
                <FiCalendar className="af-label-icon" />
                {t("adminAddEditAnimal.reproduction.dateGestation")}
              </label>
              <input type="date" className="af-input" value={reprodDG} onChange={(e) => setReprodDG(e.target.value)} />
            </div>
            <div className="af-field">
              <label className="af-label required">
                <FiActivity className="af-label-icon" />
                {t("adminAddEditAnimal.fields.status")}
              </label>
              <select className="af-select" value={statusId} onChange={(e) => setStatusId(e.target.value)} required>
                <option value="">{t("adminAddEditAnimal.placeholders.selectStatus")}</option>
                {statuss.filter((s) => s.titre !== "Avortement").map((s) => (
                  <option key={s.id} value={s.id}>{s.titre}</option>
                ))}
              </select>
            </div>
          </div>
        </div>

        {/* Submit */}
        <div className="af-actions">
          <button type="button" className="af-btn-secondary" onClick={() => navigate("/admin/animals")}>
            <FiChevronLeft />
            {t("adminAddEditAnimal.buttons.cancel") || "Annuler"}
          </button>
          <button type="submit" className="af-btn-primary">
            <FiCheckCircle />
            {edit ? t("adminAddEditAnimal.buttons.update") : t("adminAddEditAnimal.buttons.add")}
          </button>
        </div>
      </form>
    </div>
  );
};
